export default [
	// 线上订单管理
	{
		path: 'online_order_list',
		name: 'm_online_order',
		props: route => route.params,
		component: () => import('@/pages/sales/online_order_list')
	},
	// 线上售后订单
	{
		path: 'online_aftersale_list',
		name: 'm_online_aftersales_order',
		props: route => route.params,
		component: () => import('@/pages/sales/online_aftersale_list')
	},
	// 线下订单管理
	{
		path: 'offline_order_list',
		name: 'm_offline_order',
		props: route => route.params,
		component: () => import('@/pages/sales/offline_order_list')
	},
	// 线下售后订单
	{
		path: 'offline_aftersale_list',
		name: 'm_offline_aftersales_order',
		props: route => route.params,
		component: () => import('@/pages/sales/offline_aftersale_list')
	},
	// 超卖订单
	{
		path: 'oversold_list',
		name: 'm_overseal_order',
		props: route => route.params,
		component: () => import('@/pages/sales/oversold_list')
	},
	// 发货单
	{
		path: 'delivery_list',
		name: 'm_delivery',
		props: route => route.params,
		component: () => import('@/pages/sales/delivery_list')
	},
	// 暗拍推送报告
	{
		path: 'auction_push_report',
		name: 'm_auction_push_report',
		props: route => route.params,
		component: () => import('@/pages/sales/auction_push_report')
	},
	// 暗拍统计报告
	{
		path: 'auction_stat_report',
		name: 'm_auction_stat_report',
		props: route => route.params,
		component: () => import('@/pages/sales/auction_stat_report')
	},
];
